import styled from 'styled-components';
import { type ButtonProps, ButtonStyle } from '../shared/Button';
import Link, { type LinkProps } from 'next/link';

type LinkButtonProps = ButtonProps & LinkProps;

export const LinkButton = styled(Link)<LinkButtonProps>`
  ${ButtonStyle}
`;
